import { get } from "../index";

export const getQuestions = (data) => {
  let query = "";
  for (let d in { ...data })
    query +=
      data[d] || (data[d] == 0 && data[d] !== "")
        ? d + "=" + data[d] + "&"
        : "";
  return get(`/api/question?` + query);
};
